export function checkUpdatedActiveCookieCategories(
  currentCookieCategories: string[],
  activeCookieCategories: string[],
  reloadFn: () => void = location.reload.bind(location),
): string[] {
  currentCookieCategories.forEach((currentCategory) => {
    const categoryStillActive = checkIfCategoryStillActive(
      currentCategory,
      activeCookieCategories,
    );
    if (!categoryStillActive) {
      reloadFn();
    }
  });
  return activeCookieCategories;
}

function checkIfCategoryStillActive(
  currentCategory: string,
  activeCookieCategories: string[],
): string | undefined {
  return activeCookieCategories.find((ac: string) => ac === currentCategory);
}
